module.exports = __webpack_public_path__ + "static/media/bg.d6f79c1d.png";